import { IChangeBatcher } from './IChangeBatcher';

export class TimeBasedBatcher<T> implements IChangeBatcher<T> {
  private pending: T[] = [];
  private timer?: NodeJS.Timeout;
  private flushCallback?: (items: T[]) => void;

  constructor(private readonly intervalMs: number) {}

  get pendingItems(): T[] {
    return this.pending;
  }

  get isTimerActive(): boolean {
    return this.timer !== undefined;
  }

  add(items: T[]): void {
    if (items.length === 0) return;
    this.pending.push(...items);

    if (!this.timer) {
      this.timer = setTimeout(() => {
        this.flush();
      }, this.intervalMs);
    }
  }

  flush(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }

    if (this.pending.length === 0) return;

    const itemsToFlush = [...this.pending];
    this.pending = [];
    this.flushCallback?.(itemsToFlush);
  }

  clear(): void {
    this.pending = [];
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }

  hasPending(): boolean {
    return this.pending.length > 0;
  }

  onFlush(callback: (items: T[]) => void): void {
    this.flushCallback = callback;
  }
}
